<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="queryHandle()" size="small">
            <el-form-item label="A S N 编码:">
                <el-input size="small" v-model="dataForm.asncode" placeholder="ASN编码" clearable @blur="queryHandle"></el-input>
            </el-form-item>
            <el-form-item label="物料号:">
                <el-input size="small" v-model="dataForm.partCode" placeholder="物料号" clearable @blur="queryHandle"></el-input>
            </el-form-item>
            <el-form-item label="ASN状态:">
                <!-- <el-input size="small" v-model="dataForm.asnStatus" placeholder="ASN状态" clearable @blur="getDataList"></el-input> -->
                <el-select size="small" v-model="dataForm.asnStatus" placeholder="请选择ASN状态" clearable @change="queryHandle">
                    <el-option v-for="item in ASN_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="采购组:">
                <el-select size="small" v-model="dataForm.ekgrp" placeholder="请选择采购组" filterable clearable @change="queryHandle">
                    <el-option v-for="item in GOURP_LIST" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="queryHandle()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" plain type="primary" @click="exportASNData()">
                    导出交货单信息
                </el-button>
                <el-button size="small" plain type="primary" @click="importTemplate()">
                    导入交货单信息
                </el-button>
                <el-button size="small" plain type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建ASN
                </el-button>
            </el-form-item>
            <div>
                <el-form-item label="内向交货单:">
                    <el-input size="small" v-model="dataForm.innerCode" placeholder="内向交货单" clearable @blur="queryHandle"></el-input>
                </el-form-item>
                <el-form-item label="订单号:">
                    <el-input size="small" v-model="dataForm.orderCode" placeholder="订单号" clearable @blur="queryHandle"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="asnStatus" header-align="center" align="center" label="ASN状态" width="100">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.asnStatus)">
                            {{asnStatusFormat(scope.row.asnStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="syncStatus" header-align="center" align="center" label="同步状态" width="100">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.syncStatus)">
                            {{syncStatusFormat(scope.row.syncStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="asncode" header-align="center" align="left" label="ASN编码" width="150">
                </el-table-column>
                <el-table-column prop="deliveryDate" header-align="center" align="center" label="供货日期" :formatter="dateFormat" width="150">
                </el-table-column>
                <el-table-column prop="innerCode" header-align="center" align="left" label="内向交货单">
                </el-table-column>
                <el-table-column prop="groupCode" header-align="center" align="left" label="采购组">
                </el-table-column>
                <el-table-column prop="groupName" header-align="center" align="left" label="采购组描述">
                </el-table-column>
                <el-table-column prop="remark" header-align="center" align="left" label="备注">
                </el-table-column>
                <el-table-column prop="rejectReason" header-align="center" align="left" label="驳回原因">
                </el-table-column>
                <el-table-column prop="syncMessage" header-align="center" align="left" label="同步失败原因">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="240" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button :disabled="(scope.row.asnStatus === '1' || scope.row.asnStatus == '4') || scope.row.asnStatus == '5' || (scope.row.asnStatus == '2' && scope.row.syncStatus == '2')" type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button :disabled="(scope.row.asnStatus === '1' || scope.row.asnStatus == '4') || scope.row.asnStatus == '5' || (scope.row.asnStatus == '2' && scope.row.syncStatus == '2')" type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="text-danger">
                            删除
                        </el-button>
                        <el-button :disabled="!((scope.row.asnStatus == '2' || scope.row.asnStatus == '5') && scope.row.syncStatus == '2')" type="text" size="small" @click="exportData(scope.row)" icon="el-icon-edit">
                            导出
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <delivery-template-import v-if="deliveryTemplateImportVisible"  @refreshDataList="getDataList" ref="deliveryTemplateImport"></delivery-template-import>
    </div>
</div>
</template>

<script>
import {
    getLabelByValue,
    ASN_STATUS,
    SYNC_STATUS,
    PRODUCTION_ORDER_STATUS,
} from "@/utils/const";
import {
    getGroupOtsList
} from "@/controller/order"
import {
    fetchDeliveryOtsListBySupplier,
    deleteDeliveryOts,
    exportDeliveryOts,
    editDelivery,
    exportASNOtsData
} from '@/controller/delivery'
import AddOrUpdate from './delivered-add-or-update'
import DeliveryTemplateImport from './delivery-template-import'
import moment from 'moment'
// require('@/mock/mockDelivery');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                asncode: '',
                supplierName: '',
                deliveryDate: '',
                asnStatus: '',
                innerCode: '',
                remark: '',
                rejectReason: '',
                orderCode: '',
                ekgrp: ''
                // ...this.dataForm,
            },
            ASN_STATUS: ASN_STATUS,
            getLabelByValue: getLabelByValue,
            PRODUCTION_ORDER_STATUS: PRODUCTION_ORDER_STATUS,
            dataList: [],
            tenantList: [],
            GOURP_LIST: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            deliveryTemplateImportVisible: false,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    components: {
        AddOrUpdate,
        DeliveryTemplateImport
    },
    activated() {
        this.getGroupList();
        this.getDataList()
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 260
            }
        }
    },
    methods: {
        // 订单状态
        orderStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getProductionOrderStatusByValue(PRODUCTION_ORDER_STATUS, value);
        },
        // 获取采购组列表
        getGroupList() {
            this.GOURP_LIST = [];
            getGroupOtsList({}).then((data) => {
                if(data.body && data.body.length != 0) {
                    data.body.forEach((info) => {
                        const group = {
                            key: info.value,
                            value: info.value,
                            label: info.label
                        }
                        this.GOURP_LIST.push(group)
                    })
                }
            })
        },
        // 订单关闭按钮
        changeAsnStatus(row) {
            this.$confirm(`确定关闭交货单?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.asnStatus = '4',
                    editDelivery(row)
                    .then((data) => {
                        if (data && data.code === "00") {
                            this.$message({
                                message: '交货单关闭成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        asnStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(ASN_STATUS, value);
        },
        syncStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(SYNC_STATUS, value);
        },
        // 查询按钮
        queryHandle() {
            this.pageIndex = 1;
            this.getDataList();
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchDeliveryOtsListBySupplier({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                asncode: this.dataForm.asncode,
                supplierCode: this.dataForm.supplierCode,
                'supplierName': this.dataForm.supplierName,
                'deliveryDate': this.dataForm.deliveryDate,
                recieveyDate: this.dataForm.recieveyDate,
                'partCode': this.dataForm.partCode,
                asnStatus: this.dataForm.asnStatus,
                innerCode: this.dataForm.innerCode,
                remark: this.dataForm.remark,
                rejectReason: this.dataForm.rejectReason,
                orderCode: this.dataForm.orderCode,
                groupCode: this.dataForm.ekgrp
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteDeliveryOts({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        exportData(rec) {
            exportDeliveryOts(rec).then(data => {
                if (data && data.code === '00') {
                    this.readAsBinaryString(data.body)
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            // this.getDataList()
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        // 打开导入窗口
        importTemplate() {
            this.deliveryTemplateImportVisible = true
            this.$nextTick(() => {
                this.$refs.deliveryTemplateImport.init()
            })
        },
        // 批量导出交货单信息
        exportASNData () {
            const params = {
                ids : [],
                asnCode: this.dataForm.asncode,
                supplierCode: this.dataForm.supplierCode,
                partCode: this.dataForm.partCode,
                'supplierName': this.dataForm.supplierName,
                'deliveryDate': this.dataForm.deliveryDate,
                asnStatus: this.dataForm.asnStatus,
                innerCode: this.dataForm.innerCode,
                orderCode: this.dataForm.orderCode
            }
            exportASNOtsData(params).then((data) => {
                if(data && data.code == '00') {
                    this.readAsBinaryString(data.body)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch((e) => {
                console.log(e)
            })
        },
        readAsBinaryString(data) {
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
        },
        str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-primary"
                    break;
                case '3':
                    className = "text-danger"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        }
    }
}
</script>

<style lang="scss" scoped>
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
